import { render, staticRenderFns } from "./ManterEventoCalendarioView.vue?vue&type=template&id=2cdeed6a"
import script from "./ManterEventoCalendarioView.vue?vue&type=script&lang=js"
export * from "./ManterEventoCalendarioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports